<div class="error-modal">
  <div class="modal-icon error">
    <ion-icon class="icon icon-exclamation-triangle" color="danger"></ion-icon>
  </div>
  <h1 class="font-weight-regular">Unfortunately something went wrong</h1>
  @if(autoId()){
    <p class="font-weight-regular">We encountered an error opening the PDF version.</p>
  }
  @else {
    <p class="font-weight-regular">We encountered an error opening the document.</p>
  }
  <p class="font-weight-regular paragraph-extra-small">For assistance, call us at <a href="tel:866-268-6879">866-268-6879</a> (M-F 8am-7pm, Sat 9am-5:30pm CT) or contact us via <a (click)="openChat()">online chat</a> (M-F 8am-7pm CT).</p>
  <div class="row-buttons">
    <ion-button class="primary small min-width__small" (click)="cancel()">Okay</ion-button>
    <ion-button fill="clear" class="button-link small" (click)="tryAgain()">Try Again</ion-button>
  </div>
    
</div>
